export default __webpack_public_path__ + "static/media/banner-phones.b4eeda8b.png";